export const TELEPHONY_INCOMING_RESOLVED_EVENT = 'contacttel:telephony-incoming-resolved' as const;

export type TelephonyIncomingResolvedAction = 'accept' | 'reject';

export interface TelephonyIncomingResolvedEventDetail {
  callId: string;
  action: TelephonyIncomingResolvedAction;
}

/**
 * Notify the global layout that an incoming call decision was taken by the user.
 */
export function dispatchTelephonyIncomingResolved(detail: TelephonyIncomingResolvedEventDetail) {
  if (typeof window === 'undefined') {
    return;
  }
  window.dispatchEvent(
    new CustomEvent<TelephonyIncomingResolvedEventDetail>(
      TELEPHONY_INCOMING_RESOLVED_EVENT,
      { detail },
    ),
  );
}
